import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { availabilityStyles } from "@tCentro/Overrides/Widgets/ProductDetails/ProductDetailsAvailability";
import { TYPOGRAPHY } from "@tCentro/theme/design";
import { css } from "styled-components";

availabilityStyles.availability = {
    infoLinkStyles: {
        css: css`
            font-size: ${TYPOGRAPHY.size.tiny};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: 16px;
            margin-left: 4px;
            color: ${getColor("text.main")};
        `,
    },
    infoIconStyles: {
        size: 12,
        color: `${getColor("text.main")}`,
        css: css`
            svg {
                > path {
                    fill: ${getColor("text.main")} !important;
                }
            }
        `,
    },
    container: {
        gap: 0,
        css: css`
            flex-grow: 0;
            margin-top: 0px;
        `,
    },
    messageGridItem: {
        width: 12,
        css: css`
            div[class^="InventoryMessage"] {
                padding: 14px;
            }
            span[data-test-selector^="availabilityMessage"] {
                font-size: 12px;
                font-style: normal;
                color: ${getColor("text.main")};
                font-weight: 600;
                line-height: 16px;
                white-space: pre;
            }
        `,
    },
};
